import React from 'react'

import useViewModel from './ViewModel'

const ActiveComponent = () => {
	return (
		<span className="d-inline-block bg-kumopack-success-500 p-1 rounded-circle w-2px h-2px me-1" />
	)
}

const MarketplaceBoughtChart: React.FC = () => {
	const { chartRef, currentDataType, setCurrentDataType } = useViewModel()

	return (
		<div className={`card border border-kumopack-grey-200  position-relative`}>
			{/* begin::Body */}
			<div className="card-body p-0">
				{/* begin::Chart */}
				<div
					ref={chartRef}
					id="kt_charts_member_types_chart"
					style={{ height: '350px' }}
					className="card-rounded-bottom"></div>
				{/* end::Chart */}
			</div>
			{/* end::Body */}

			<div className="position-absolute z-2" style={{ top: '5%', right: '2%' }}>
				<div className="w-fit-content">
					<div className="kumopack-button-group">
						<button
							className="btn btn-sm white-button text-kumopack-grey-700 fw-bold left"
							onClick={() => setCurrentDataType('order')}>
							{currentDataType === 'order' && <ActiveComponent />} คำสั่งซื้อ
						</button>
						<button
							className="btn btn-sm white-button text-kumopack-grey-700 fw-bold right"
							onClick={() => setCurrentDataType('sale')}>
							{currentDataType === 'sale' && <ActiveComponent />} ยอดขาย
						</button>
						{/* <button
							className="btn btn-sm white-button text-kumopack-grey-700 fw-bold right"
							onClick={() => setCurrentDataType('bought')}>
							{currentDataType === 'bought' && <ActiveComponent />} อัตราการซื้อสินค้า
						</button> */}
					</div>
				</div>
			</div>
		</div>
	)
}

export default MarketplaceBoughtChart
